import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'
import { getSubLabel } from 'lib/util/string'
import Text from 'ui/Element/Text'

const styles = theme => ({
  row: {
    gap: 12,
    flexWrap: 'nowrap',
  },
  subLabel: {
    gap: 4,
  },
})

const hasValue = x => !!x && x?.length && x !== '-'

/**
 * Displays information about a person.
 *
 * @param {Object} classes  element's style classes
 * @param {Object} props    element's properties
 *
 * @returns {JSX.Element}
 */
export const ListItemCellPersonInformation = (classes, props = {}) => {
  const { name, firstName = '-', lastName = '-', emailLabel, contactChannels = [] } = props || {}

  const email = contactChannels.find(channel => channel.type === 'email')?.value
  const subLabel = getSubLabel(Text, [emailLabel, email])

  const shownName = hasValue(name) ? name : `${firstName} ${lastName}`

  return (
    <Grid
      container
      direction={'row'}
      className={classes.row}
    >
      <Grid
        item
        xs={'auto'}
        alignSelf={'stretch'}
      >
        <Grid
          container
          gap={'0.125rem'}
          direction={'column'}
          alignItems={'flex-start'}
          justifyContent={'center'}

          sx={{ height: '100%' }}
        >
          <Text
            maxLines={1}
            value={shownName}
            variant={'14/bold'}
            color={'black.main'}
          />
          {emailLabel && contactChannels && (
            <Grid
              item
              container
              xs={'auto'}
              className={classes.subLabel}
            >
              {subLabel}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CellHOC(ListItemCellPersonInformation, styles)
